module.exports = __webpack_public_path__ + "fonts/opensans-italic.f8d7dc5e.ttf";